
<canvas #barcodeCanvas></canvas>